import { logger, ILogger } from './actions';
import immerHandleActions from '@Redux/utils/immerHandleActions';

const init = {
	logger: '',
};

type draft = typeof init;

export interface ILoggerDraft extends draft {}

const reducers = {
	[logger.toString()](draft: draft, action: ILogger) {
		const loggerPath = action.payload ? `${draft.logger} -> ${action.payload}` : '';
		return { logger: loggerPath };
	},
};

export default immerHandleActions(reducers, init);
